// Renders a metric label and shows a trailing " *" marker in red.
const MetricLabel = ({ label }) => {
  if (typeof label === 'string' && label.endsWith(' *')) {
    return (
      <>
        {label.slice(0, -2)} <span className="text-danger fw-bold">*</span>
      </>
    )
  }
  return <>{label}</>
}

export default MetricLabel
